import { IQuyDinhSoTinChiActionTypes } from "../../action-types/quan-ly-dang-ky/IQuyDinhSoTinChiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IQuyDinhSoTinChiReducer } from "../../reducer-model/quan-ly-dang-ky/IQuyDinhSoTinChiReducer";

const iniState: IQuyDinhSoTinChiReducer = {
    status: eReducerStatusBase.is_not_initialization,
    quyDinhSoTinChis: [],
    selectedIds: [],
    focusedId: 0,
    isShowEditModal: false,
    quyDinhSoTinChiEditing: undefined,
};

export const quyDinhSoTinChiReducer = (
    state: IQuyDinhSoTinChiReducer = iniState,
    action: IQuyDinhSoTinChiActionTypes
): IQuyDinhSoTinChiReducer => {
    switch (action.type) {
        case "QUY_DINH_SO_TIN_CHI_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "QUY_DINH_SO_TIN_CHI_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                quyDinhSoTinChis: action.payload,
            };
        case "QUY_DINH_SO_TIN_CHI_LOAD_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };

        case "QUY_DINH_SO_TIN_CHI_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "QUY_DINH_SO_TIN_CHI_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
                quyDinhSoTinChiEditing: undefined,
            };
        case "QUY_DINH_SO_TIN_CHI_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };

        case "QUY_DINH_SO_TIN_CHI_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "QUY_DINH_SO_TIN_CHI_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                selectedIds: [],
            };
        case "QUY_DINH_SO_TIN_CHI_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };

        case "QUY_DINH_SO_TIN_CHI_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                quyDinhSoTinChiEditing: action.payload,
            };
        case "QUY_DINH_SO_TIN_CHI_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
                quyDinhSoTinChiEditing: undefined,
            };

        case "QUY_DINH_SO_TIN_CHI_CHANGE_SELECTED_IDS":
            return {
                ...state,
                selectedIds: action.payload,
            };
        case "QUY_DINH_SO_TIN_CHI_CHANGE_FOCUSED_ID":
            return {
                ...state,
                focusedId: action.payload,
            };
        case "QUY_DINH_SO_TIN_CHI_SUBMIT_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "QUY_DINH_SO_TIN_CHI_SUBMIT_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "QUY_DINH_SO_TIN_CHI_SUBMIT_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "QUY_DINH_SO_TIN_CHI_LOAD_BY_HOC_KY_NAM_HOC_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            };
        case "QUY_DINH_SO_TIN_CHI_LOAD_BY_HOC_KY_NAM_HOC_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                quyDinhSoTinChis: action.payload,
            };
        case "QUY_DINH_SO_TIN_CHI_LOAD_BY_HOC_KY_NAM_HOC_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
       
        default:
            return state;
    }
};
